/*
  LEIBISH header controller (v2) — the only JS the rebuilt header ships.
  Everything visual lives in CSS; this file only flips state classes and
  lazy-loads the optional extras. All listeners are delegated/passive so the
  theme editor can re-inject the section HTML without re-initialization.

  Contracts preserved from the legacy Alpine implementation:
  - #sticky-header gets .sticky-header / .header-up / .on-scroll-up-animation /
    .reduce-logo-size (consumed by theme.css, the section's inline CSS and
    Alpine.store('xMiniCart').openCart in theme.js).
  - CSS variables --top-header / --height-header / --header-container-height.
*/
(function () {
  'use strict';

  var container = document.getElementById('x-header-container');
  var lgQuery = window.matchMedia('(min-width: 1024px)');
  // document.currentScript is only set while this file executes — capture now.
  var accountIconsSrc = (document.currentScript && document.currentScript.getAttribute('data-account-icons')) || '';

  /* ------------------------------------------------------------------ *
   * 1. Sticky header (non-transparent pages only — transparent templates
   *    keep the legacy Alpine machinery in theme.js).
   * ------------------------------------------------------------------ */
  function initSticky() {
    // sections/header.liquid renders both headers on DYO product pages and x-show
    // hides this one while the design flow runs, so measuring it would publish a
    // 0px --height-header over the value the DYO header (theme.js) owns.
    if (document.body.classList.contains('dyo-product-page')) return;

    container = document.getElementById('x-header-container');
    if (!container) return;
    var stickyType = container.getAttribute('data-header-sticky');
    if (!stickyType || stickyType === 'none') return;

    var stickyEl = document.getElementById('sticky-header');
    var stickyContent = document.getElementById('sticky-header-content');
    if (!stickyEl || !stickyContent) return;

    var offsetTop = 0;
    var stickyHeight = 0;
    var lastScrollTop = 0;
    var rafId = null;
    var animTimer = null;
    var topHeaderValue = null;
    var containerHeightValue = null;
    var heightHeaderValue = null;

    function measure() {
      // Off the scroll path: init / resize / fonts / pin-unpin only.
      // Keep every layout read before every style write. Reading container height
      // after setting a CSS variable forced the browser to synchronously reflow.
      var nextOffsetTop = container.offsetTop;
      var nextStickyHeight = stickyEl.offsetHeight;
      var nextTopHeader = stickyContent.offsetHeight;
      var nextContainerHeight = container.offsetHeight;

      offsetTop = nextOffsetTop;
      stickyHeight = nextStickyHeight;

      if (topHeaderValue !== nextTopHeader) {
        topHeaderValue = nextTopHeader;
        document.documentElement.style.setProperty('--top-header', nextTopHeader + 'px');
      }
      if (containerHeightValue !== nextContainerHeight) {
        containerHeightValue = nextContainerHeight;
        document.documentElement.style.setProperty('--header-container-height', nextContainerHeight + 'px');
      }
    }

    function setHeightVar(sticky) {
      var nextHeightHeader = sticky ? stickyHeight : 0;
      if (heightHeaderValue === nextHeightHeader) return;
      heightHeaderValue = nextHeightHeader;
      document.documentElement.style.setProperty('--height-header', nextHeightHeader + 'px');
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > offsetTop) {
          if (!stickyEl.classList.contains('sticky-header')) {
            stickyEl.classList.add('sticky-header', 'reduce-logo-size');
            clearTimeout(animTimer);
            if (stickyType === 'on-scroll-up') {
              animTimer = setTimeout(function () {
                stickyEl.classList.add('on-scroll-up-animation');
              }, 500);
            }
            requestAnimationFrame(measure);
          }
        } else if (stickyEl.classList.contains('sticky-header')) {
          clearTimeout(animTimer);
          stickyEl.classList.remove('sticky-header', 'reduce-logo-size', 'always-animation', 'on-scroll-up-animation', 'header-up', 'opacity-0');
          setHeightVar(false);
          requestAnimationFrame(measure);
        }

        if (stickyType === 'on-scroll-up' && Math.abs(scrollTop - lastScrollTop) > 10) {
          if (scrollTop < lastScrollTop) {
            stickyEl.classList.remove('header-up', 'opacity-0');
            setHeightVar(true);
          } else {
            stickyEl.classList.add('header-up');
            setHeightVar(false);
          }
          lastScrollTop = scrollTop;
        }
      });
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        measure();
      });
    }, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { requestAnimationFrame(measure); });
    }

    // theme.js xMiniCart.openCart reads Alpine.store('xHeaderMenu').stickyType to
    // re-reveal a scroll-hidden header when the cart opens — keep it in sync.
    document.addEventListener('alpine:initialized', function () {
      if (window.Alpine && window.Alpine.store('xHeaderMenu')) {
        window.Alpine.store('xHeaderMenu').stickyType = stickyType;
      }
    });
  }

  // The DYO product flow keeps a body[x-cloak] overlay while it boots; wait for
  // it like the legacy initSticky did.
  function whenReady(fn) {
    if (document.querySelector('body[x-cloak]') === null) {
      fn();
    } else {
      setTimeout(function () { whenReady(fn); }, 150);
    }
  }
  whenReady(initSticky);

  /* ------------------------------------------------------------------ *
   * 2. Mobile drawer (native popover) — scroll lock + fallback + a11y.
   * ------------------------------------------------------------------ */
  var nav = document.getElementById('leibish-mobile-nav');
  var supportsPopover = typeof HTMLElement !== 'undefined' && 'togglePopover' in HTMLElement.prototype;

  function lockBody(lock) {
    var body = document.body;
    if (lock) {
      var scrollbar = window.innerWidth - document.documentElement.clientWidth;
      body.style.overflow = 'hidden';
      if (scrollbar > 0) body.style.paddingInlineEnd = scrollbar + 'px';
    } else {
      body.style.overflow = '';
      body.style.paddingInlineEnd = '';
    }
  }

  if (nav && supportsPopover) {
    nav.addEventListener('toggle', function (e) {
      lockBody(e.newState === 'open');
    });
  }

  if (!supportsPopover) {
    // Minimal fallback for browsers without the Popover API: same markup,
    // class-driven visibility (see .drawer-open rules in theme.css.liquid).
    var backdrop = null;
    var closeDrawer = function () {
      if (!nav) return;
      nav.classList.remove('drawer-open');
      if (backdrop) backdrop.remove();
      backdrop = null;
      lockBody(false);
    };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[popovertarget="leibish-mobile-nav"]');
      if (!btn) return;
      nav = document.getElementById('leibish-mobile-nav');
      if (!nav) return;
      e.preventDefault();
      if (btn.getAttribute('popovertargetaction') === 'hide' || nav.classList.contains('drawer-open')) {
        closeDrawer();
      } else {
        nav.classList.add('drawer-open');
        backdrop = document.createElement('div');
        backdrop.className = 'header-nav-backdrop';
        backdrop.addEventListener('click', closeDrawer);
        nav.parentNode.insertBefore(backdrop, nav);
        lockBody(true);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // Close the drawer when the viewport grows into the desktop layout.
  lgQuery.addEventListener('change', function (e) {
    if (!e.matches) return;
    nav = document.getElementById('leibish-mobile-nav');
    if (!nav) return;
    if (supportsPopover && nav.matches(':popover-open')) nav.hidePopover();
    nav.classList.remove('drawer-open');
    lockBody(false);
  });

  // Slide-over stack a11y + scroll reset (checkbox pattern is CSS-only;
  // this just decorates it).
  function hydrateDeferredNavImages(root) {
    if (!root) return;
    root.querySelectorAll('img[data-mobile-nav-deferred-image]').forEach(function (img) {
      // The panel is now open, so the image is wanted: load it immediately.
      // Leaving loading="lazy" would re-defer the just-hydrated src and, in
      // browsers that honor lazy inside a hidden/offscreen sub-panel (iOS Safari),
      // the icon never paints until scrolled into view.
      img.loading = 'eager';
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
      img.removeAttribute('data-mobile-nav-deferred-image');
    });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.matches('[data-nav-toggle]')) return;
    var labels = document.querySelectorAll('label[for="' + cb.id + '"]');
    labels.forEach(function (l) { l.setAttribute('aria-expanded', cb.checked ? 'true' : 'false'); });
    if (cb.checked) {
      var panel = cb.parentElement.querySelector(':scope > .toggle-menu, :scope > .nav-panel--sub');
      if (panel) {
        panel.scrollTop = 0;
        hydrateDeferredNavImages(panel);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!e.target.closest) return;
    var label = e.target.closest('label[data-nav-label]');
    if (!label || (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar')) return;
    e.preventDefault();
    label.click();
  });

  /* ------------------------------------------------------------------ *
   * 3. Desktop touch devices (iPad): first tap opens the panel, second
   *    tap follows the link — parity with the legacy touchItem handler.
   * ------------------------------------------------------------------ */
  document.addEventListener('touchend', function (e) {
    if (window.innerWidth < 1024) return;
    var title = e.target.closest('.header-nav .has-dropdown a.nav-item__title');
    var item = title && title.closest('.has-dropdown');
    if (item && !item.classList.contains('nav-touched')) {
      e.preventDefault();
      document.querySelectorAll('.header-nav .nav-touched').forEach(function (el) {
        el.classList.remove('nav-touched');
      });
      item.classList.add('nav-touched');
    } else if (!e.target.closest('.header-nav .has-dropdown')) {
      document.querySelectorAll('.header-nav .nav-touched').forEach(function (el) {
        el.classList.remove('nav-touched');
      });
    }
  }, { passive: false });

  /* ------------------------------------------------------------------ *
   * 4. Account dropdown icon-injector — heavy and rarely needed up front,
   *    so it lives in header-account-icons.js and loads on intent.
   * ------------------------------------------------------------------ */
  var iconsLoaded = false;
  function loadAccountIcons() {
    if (iconsLoaded || !accountIconsSrc) return;
    iconsLoaded = true;
    if (window.Eurus && window.Eurus.loadedScript && window.Eurus.loadedScript.has('header-account-icons')) return;
    if (window.Eurus && window.Eurus.loadedScript) window.Eurus.loadedScript.add('header-account-icons');
    var s = document.createElement('script');
    s.src = accountIconsSrc;
    s.defer = true;
    document.head.appendChild(s);
  }
  document.addEventListener('pointerenter', function (e) {
    if (e.target && e.target.closest && e.target.closest('shopify-account')) loadAccountIcons();
  }, { capture: true, passive: true });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('shopify-account')) loadAccountIcons();
  });
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadAccountIcons, { timeout: 8000 });
  } else {
    setTimeout(loadAccountIcons, 8000);
  }

  /* ------------------------------------------------------------------ *
   * 4b. Cart drawer lazy hydration. The header renders only a skeleton
   *     shell (#CartDrawer with [data-cart-skeleton]); the real content is
   *     fetched via the Section Rendering API on cart-icon intent, or on
   *     idle when the cart already has items. Add-to-cart responses hydrate
   *     the same shell through the existing product-cart.js code path.
   * ------------------------------------------------------------------ */
  var cartFetchStarted = false;
  function hydrateCartDrawer() {
    if (cartFetchStarted) return;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    if (!drawer.querySelector('[data-cart-skeleton]')) { cartFetchStarted = true; return; }
    cartFetchStarted = true;
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data['cart-drawer']) return;
        var d = document.getElementById('CartDrawer');
        if (!d || !d.querySelector('[data-cart-skeleton]')) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var content = doc.querySelector('#CartDrawer');
        if (content) d.innerHTML = content.innerHTML;
      })
      .catch(function () { cartFetchStarted = false; });
  }
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-cart-trigger]')) hydrateCartDrawer();
    }, { capture: true, passive: true });
  });
  (function () {
    var bubble = document.getElementById('cart-icon-bubble') || document.getElementById('mobile-cart-icon-bubble');
    var count = bubble ? parseInt(bubble.getAttribute('data-value'), 10) : 0;
    if (count > 0) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(hydrateCartDrawer, { timeout: 3000 });
      } else {
        setTimeout(hydrateCartDrawer, 3000);
      }
    }
  })();

  /* ------------------------------------------------------------------ *
   * 5b. SKU multi-search (moved from the per-instance inline script in
   *     header-search-block.liquid): a comma/space list of SKU-looking
   *     tokens becomes a variants.sku OR query.
   * ------------------------------------------------------------------ */
  function isSkuToken(t) {
    return /^[0-9]+$/.test(t) || /^[A-Za-z][0-9]+$/.test(t) || /^[0-9]+[A-Za-z]$/.test(t);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.js-sku-search');
    if (!form) return;
    var visible = form.querySelector('input[type="search"]');
    var hiddenQuery = form.querySelector('input[type="hidden"][id^="sku-query"]');
    var hiddenPref = form.querySelector('input[type="hidden"][id^="sku-prefix"]');
    if (!visible || !hiddenQuery || !hiddenPref) return;

    var raw = visible.value.trim();
    var tokens = raw.split(/[\s,]+/).filter(Boolean);
    var isSkuList = tokens.length > 1 && tokens.every(isSkuToken);

    if (!isSkuList) {
      visible.disabled = false;
      visible.setAttribute('name', 'q');
      hiddenQuery.disabled = true;
      hiddenPref.disabled = true;
      return;
    }

    e.preventDefault();
    hiddenQuery.value = tokens.map(function (sku) { return 'variants.sku:' + sku; }).join(' OR ');
    hiddenPref.value = 'none';
    hiddenQuery.disabled = false;
    hiddenPref.disabled = false;
    visible.disabled = true;
    visible.removeAttribute('name');
    form.submit();
  });

  /* ------------------------------------------------------------------ *
   * 6. Theme editor: re-measure after Shopify re-injects the section.
   * ------------------------------------------------------------------ */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      whenReady(initSticky);
    });
  }
})();
